import { createContext as o, useContext as e } from "react";
const n = o(null);
n.displayName = "ConfigContext";
const c = () => {
  const t = e(n);
  if (t === null)
    throw new Error("config context was null");
  return t;
};
export {
  n as ConfigContext,
  c as useConfig
};
//# sourceMappingURL=index.js.map
